import { useMemo } from 'react';

import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';

interface IUseGetFoldersAndFilesFromParsedData {
    parsedFilesData: IFIleEntity[];
}

export const useGetFoldersAndFilesFromParsedData = ({
    parsedFilesData,
}: IUseGetFoldersAndFilesFromParsedData) => {
    const { folders, files } = useMemo(() => {
        if (!parsedFilesData) return { folders: [], files: [] };
        return parsedFilesData.reduce(
            (
                acc: {
                    folders: IFIleEntity[];
                    files: IFIleEntity[];
                },
                file: IFIleEntity
            ) => {
                if (file?.mimeType === null) {
                    acc.folders.push(file);
                } else {
                    acc.files.push(file);
                }
                return acc;
            },
            { folders: [], files: [] }
        );
    }, [parsedFilesData]);
    return { folders, files };
};
